export default {
    api: {
        sso: {
            api_uri: process.env.REACT_APP_SSO_API_URI || 'https://sso.allbin.se',
            login_uri: process.env.REACT_APP_SSO_LOGIN_URI || 'https://login.allbin.se'
        },
    },
    slack: {
        webhook_uri: process.env.REACT_APP_SLACK_WEBHOOK_URI || 'https://hooks.slack.com/services/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'
    },
    dashboard: {
        root_uri: process.env.REACT_APP_DASHBOARD_ROOT_URI || 'https://dashboard.allbin.se'
    },
    service_name: "dashboard",

    services_to_not_show: [
        "dashboard"
    ],

    production: process.env.NODE_ENV === "production",
    send_errors_to_slack_in_dev: false
};



// WEBPACK FOOTER //
// ./src/config.js